import EzModalController from 'layouts/modal/modal-controller';
import ProgressBar from 'progressbar.js'; // eslint-disable-line import/no-unresolved, import/extensions
import { triggerCustomEvent } from 'lib/helpers';
import { getCustomerFeedbackModal } from 'lib/download-helpers';
import {
  sendTrackingEvent,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import {
  JOIN_PRO_COMPLETE,
  JOIN_PRO_TRIGGERED,
} from 'components/analytics/conversions/constants/actions';

declare global {
  interface Window {
    properBuildSlots:() => void;
  }
}

export default class DownloadPopupController extends EzModalController {
  declare readonly element:HTMLElement;

  declare readonly countTarget:HTMLElement;

  declare readonly adTemplateTarget:HTMLElement;

  declare readonly adWrapTarget:HTMLElement;

  declare readonly downloadPopupContentTarget:HTMLElement;

  declare count:number;

  declare dlSize:string;

  declare adsScriptLoaded:boolean;

  static targets = [
    'timer',
    'count',
    'adWrap',
    'adTemplate',
    'finishIcon',
    'downloadPopupContent',
  ];

  connect() {
    super.connect();

    this.count = parseInt(this.countTarget.innerHTML, 10);

    this.initAd();
    this.setupAdCountdown();
  }

  close(event) {
    super.close(event,
      () => { /* do nothing */ },
      () => getCustomerFeedbackModal({ manualTrigger: true }));
  }

  initAd() {
    this.adsScriptLoaded = false;

    const adTemplate = this.adTemplateTarget.innerHTML;

    this.adWrapTarget.insertAdjacentHTML('beforeend', adTemplate);

    const properAdsScriptCheck = setInterval(() => {
      if (this.properBuildSlotsReady && !this.adsScriptLoaded) {
        window.properBuildSlots();

        this.adsScriptLoaded = true;
      }

      if (this.properBuildSlotsReady) {
        clearInterval(properAdsScriptCheck);
      }
    }, 100);
  }

  get properBuildSlotsReady() {
    if (typeof window.properBuildSlots === 'undefined') return false;

    return true;
  }

  setupAdCountdown() {
    // We need to add an extra second at the beginning
    // so we see the first number count down
    setTimeout(() => {
      this.dlAdCountdown();
    }, 1000);

    const dlAdTimer = new ProgressBar.Circle('[data-download-popup-target="timer"]', {
      strokeWidth: 7,
      easing: 'easeInOut',
      duration: this.count * 1000,
      color: '#999999',
      trailColor: '#cccccc',
      trailWidth: 7,
      svgStyle: null,
    });

    dlAdTimer.animate(1.0); // Number from 0.0 to 1.0
  }

  dlAdCountdown = () => {
    if (Number.isNaN(this.count)) {
      this.finishAndDownload();
    } else {
      this.count -= 1;

      if (this.count < 0) {
        this.finishAndDownload();
      } else {
        this.countTarget.innerHTML = this.count.toString();

        setTimeout(this.dlAdCountdown, 1000);
      }
    }
  }

  finishAndDownload() {
    const { dlSize, downloadFileUrl } = this.downloadPopupContentTarget.dataset;

    this.setUpAdFinish();

    triggerCustomEvent('TriggerDownload', { size: dlSize, downloadFileUrl });
  }

  setUpAdFinish() {
    this.element.querySelector('#download-popup-modal').classList.remove('is-counting-down');
    this.element.removeAttribute('data-disable-easy-close');

    const header = this.element.querySelector('.download-popup__header') as HTMLElement;
    header.innerHTML = header.dataset.started;

    const timer = this.element.querySelector('.download-popup__timer') as HTMLElement;
    const proUpsell = this.element.querySelector('.download-popup__pro-join') as HTMLElement;
    this.addHiddenClass(timer);
    this.removeHiddenClass(proUpsell);

    this.downloadPopupContentTarget.classList.add('is-complete');

    sendTrackingEvent({
      data: {
        action: JOIN_PRO_TRIGGERED,
        category: 'Trigger-Download_Complete',
        label: 'Free',
      },
    });
  }

  addHiddenClass(element) {
    element.classList.add('hidden');
  }

  removeHiddenClass(element) {
    element.classList.remove('hidden');
  }

  trackJoinProClick() {
    trackCompleteEvent({
      action: JOIN_PRO_COMPLETE,
      category: 'Trigger-Download_Complete',
    });
  }
}
